module.exports = __webpack_public_path__ + "static/img/sort-back6.aa37cf8a.png";